import { LoadDataParams } from '../../../interfaces/DataSource/DataSourceParams.interface';
import { DunaValidationStatus } from '../../../dto/users/user-status.dto';

export type DirectorySortColumn = 'identity' | 'meta' | 'stamp' | 'progress';
export type DirectorySortDirection = 'asc' | 'desc';

export function toggleDirectorySort(
  current: DirectorySortColumn,
  direction: DirectorySortDirection,
  clicked: DirectorySortColumn
): { column: DirectorySortColumn; direction: DirectorySortDirection } {
  if (current === clicked) {
    return {
      column: clicked,
      direction: direction === 'asc' ? 'desc' : 'asc',
    };
  }
  return { column: clicked, direction: 'asc' };
}

export function mapUserListSortToApi(
  column: DirectorySortColumn,
  direction: DirectorySortDirection
): { active: string; direction: DirectorySortDirection } {
  switch (column) {
    case 'identity':
      return { active: 'name', direction };
    case 'progress':
      return { active: 'registered_percentage', direction };
    case 'stamp':
      return { active: 'validation_status', direction };
    case 'meta':
      return { active: 'educational_paths', direction };
    default:
      return { active: 'registeredPercentage', direction: 'desc' };
  }
}

export function mapLocationListSortToApi(
  column: DirectorySortColumn,
  direction: DirectorySortDirection
): { active: string; direction: DirectorySortDirection } {
  switch (column) {
    case 'identity':
      return { active: 'locations_name', direction };
    case 'meta':
      return { active: 'firefighter_count', direction };
    case 'stamp':
      return { active: 'ok_percentage', direction };
    case 'progress':
      return { active: 'registered_percentage', direction };
    default:
      return { active: 'locations_name', direction: 'asc' };
  }
}

export function buildServerLoadParams(
  dataSourceKey: string,
  pageIndex: number,
  pageSize: number,
  search: string,
  sortColumn: DirectorySortColumn,
  sortDirection: DirectorySortDirection,
  mapSort: (
    column: DirectorySortColumn,
    direction: DirectorySortDirection
  ) => { active: string; direction: DirectorySortDirection },
  extraFilters: LoadDataParams['filters'] = []
): LoadDataParams {
  const trimmedSearch = search.trim();
  return {
    dataSourceKey,
    searchQuery: trimmedSearch || undefined,
    filters: [
      ...extraFilters,
      { column: 'pageSize', value: pageSize, operator: 'eq' },
      { column: 'pageIndex', value: pageIndex, operator: 'eq' },
    ],
    sort: mapSort(sortColumn, sortDirection),
  };
}

/** @deprecated UI-only; server search handles matching */
export function dunaValidationDisplayLabel(
  status: DunaValidationStatus | string | null | undefined
): string {
  switch (status) {
    case 'valid':
      return 'DUNA Gyldig';
    case 'attention':
      return 'DUNA Opmærksom';
    case 'no_data':
      return 'DUNA Ny';
    case 'no_paths':
      return 'DUNA Ingen uddannelsesveje';
    default:
      return 'DUNA Opmærksom';
  }
}
